// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import IconLink from '../../../atoms/icon-link/react/IconLink';

const Back = ({
  setStepKey,
}: {
  setStepKey: (key: string) => void,
}): React$MixedElement => (
  <div className="burger__back">
    <IconLink onClick={() => setStepKey('start')} icon="arrow-left-line">
      {t('Zurück')}
    </IconLink>
  </div>
);
export default Back;
